import "core-js/modules/es6.string.link";
// http://tapd.oa.com/qqlivechild/markdown_wikis/show/#1210120971001141581
// - 参数
// {
//   "destination": "", //分享目标，是1:微信好友，2:微信朋友圈，3:保存到相册，3.6.0只支持1，2
//   "method": "", //1:图片方式，2:h5方式，3:视频方式，4:文本方式，3.6.0只支持1，2
//   "shareInfo": {
//     "url": "https://v.qq.com", //用链接方式分享，必须有有url
//     "title": "主标题",
//     "subTitle": "副标题",
//     "singleTitle": "朋友圈标题",
//     "imageUrl": "https://xxx.jpg", //3.6.0先不支持
//     "image": "String", //base64编码，如果存在image，就忽略imageUrl参数，3.6.0先支持image方式
//     "thumbnail": "String", //base64编码，缩略图
//   },
// }
var DESTINATION = {
  'weixin': 1,
  'wxmoments': 2,
  'save': 3 // 暂不支持

};
export function xqeShare(channel, shareInfo) {
  var method = shareInfo.imgbase64 ? 1 : 2;
  TenvideoJSBridge.invoke('xqe_app_module_shareTo', {
    destination: DESTINATION[channel],
    method: method,
    shareInfo: {
      url: shareInfo.link || window.location.href,
      image: shareInfo.imgbase64 || shareInfo.kidBase64,
      title: shareInfo.title,
      subTitle: shareInfo.content || shareInfo.subTitle,
      singleTitle: shareInfo.singleTitle ? shareInfo.singleTitle : "".concat(shareInfo.title, "\u3002").concat(shareInfo.content),
      imageUrl: shareInfo.img || shareInfo.imageUrl
    }
  }, function (res) {
    console.log(res);
  });
}